export default __webpack_public_path__ + "static/productsMask-8fb2ef1c2c590ac47ea32a19ddfd2646.svg";